import { authHeader } from "../../../../auth";
export default {

    data() {
        return {
            dataList: [],
            customBrandId: this.$route.params.customBrandId,
            siteUrl: this.$serverURL + this.$api.brandDetailsPage.getCustomProducts + '/' + this.$route.params.customBrandId,
            crudUrl: this.$serverURL + this.$api.brandDetailsPage.addCustomProduct
        }
    },
    async created() {
        document.title = "Dispo - Custom Product List";
        this.dataList = await this.getDataList(this.siteUrl);
        var scripts = [
            "/core/assets/plugins/datatable/js/jquery.dataTables.min.js",
            "/core/assets/plugins/datatable/js/dataTables.bootstrap5.min.js",
            "/core/assets/js/table-datatable.js"
        ];
        scripts.forEach(script => {
            let tag = document.createElement("script");
            tag.setAttribute("src", script);
            document.head.appendChild(tag);
        });

        let style = document.createElement('link');
        style.type = "text/css";
        style.rel = "stylesheet";
        style.href = '/core/assets/plugins/datatable/css/dataTables.bootstrap5.min.css';
        document.head.appendChild(style);
    },
    methods: {
        deleteProduct: async function (id) {
            this.$swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        let config = {
                            method: 'DELETE',
                            url: this.crudUrl + '/' + id,
                            headers: {
                                ...authHeader(),
                            }
                        }
                        await this.deleteData(config);
                        this.dataList = await this.getDataList(this.siteUrl);

                    } catch (error) {
                        this.$swal.fire({
                            icon: "error",
                            text: "Something went wrong, please try agian later." + error
                        });
                    }
                }
            })
        },
        toTitleCase: function (str) {
            if (str) {
                return str.replace(/\w\S*/g, function (txt) {
                    let text = txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                    if (text.includes("_")) {
                        let str = text.split("_");
                        let final_str = "";
                        for (let i = 0; i < str.length; i++) {
                            let new_str = str[i].charAt(0).toUpperCase() + str[i].substr(1).toLowerCase();
                            final_str += new_str + ' ';
                        }
                        return final_str.trim();
                    }
                    return text;
                });
            } else {
                return;
            }
        },
    }
}